
import { macroCondition, getGlobalConfig } from '@embroider/macros';


import defineModule0 from "./-embroider-implicit-modules.js";

import * as amdModule0 from "./adapters/application.js"
import * as amdModule1 from "./adapters/school.js"
import * as amdModule2 from "./authenticators/ilios-jwt.js"
import * as amdModule3 from "./classes/event.js"
import * as amdModule4 from "./classes/events-base.js"
import * as amdModule5 from "./classes/yup-validations.js"
import * as amdModule6 from "./config/environment.js"
import * as amdModule7 from "./deprecation-workflow.js"
import * as amdModule8 from "./inflector.js"
import * as amdModule9 from "./instance-initializers/sentry-performance.js"
import * as amdModule10 from "./models/aamc-method.js"
import * as amdModule11 from "./models/aamc-pcrs.js"
import * as amdModule12 from "./models/aamc-resource-type.js"
import * as amdModule13 from "./models/academic-year.js"
import * as amdModule14 from "./models/assessment-option.js"
import * as amdModule15 from "./models/authentication.js"
import * as amdModule16 from "./models/cohort.js"
import * as amdModule17 from "./models/competency.js"
import * as amdModule18 from "./models/course-clerkship-type.js"
import * as amdModule19 from "./models/course-learning-material.js"
import * as amdModule20 from "./models/course-objective.js"
import * as amdModule21 from "./models/course.js"
import * as amdModule22 from "./models/curriculum-inventory-academic-level.js"
import * as amdModule23 from "./models/curriculum-inventory-export.js"
import * as amdModule24 from "./models/curriculum-inventory-institution.js"
import * as amdModule25 from "./models/curriculum-inventory-report.js"
import * as amdModule26 from "./models/curriculum-inventory-sequence-block.js"
import * as amdModule27 from "./models/curriculum-inventory-sequence.js"
import * as amdModule28 from "./models/ilm-session.js"
import * as amdModule29 from "./models/ingestion-exception.js"
import * as amdModule30 from "./models/instructor-group.js"
import * as amdModule31 from "./models/learner-group.js"
import * as amdModule32 from "./models/learning-material-status.js"
import * as amdModule33 from "./models/learning-material-user-role.js"
import * as amdModule34 from "./models/learning-material.js"
import * as amdModule35 from "./models/mesh-concept.js"
import * as amdModule36 from "./models/mesh-descriptor.js"
import * as amdModule37 from "./models/mesh-previous-indexing.js"
import * as amdModule38 from "./models/mesh-qualifier.js"
import * as amdModule39 from "./models/mesh-term.js"
import * as amdModule40 from "./models/mesh-tree.js"
import * as amdModule41 from "./models/offering.js"
import * as amdModule42 from "./models/pending-user-update.js"
import * as amdModule43 from "./models/program-year-objective.js"
import * as amdModule44 from "./models/program-year.js"
import * as amdModule45 from "./models/program.js"
import * as amdModule46 from "./models/report.js"
import * as amdModule47 from "./models/school-config.js"
import * as amdModule48 from "./models/school.js"
import * as amdModule49 from "./models/session-learning-material.js"
import * as amdModule50 from "./models/session-objective.js"
import * as amdModule51 from "./models/session-type.js"
import * as amdModule52 from "./models/session.js"
import * as amdModule53 from "./models/term.js"
import * as amdModule54 from "./models/user-role.js"
import * as amdModule55 from "./models/user-session-material-status.js"
import * as amdModule56 from "./models/user.js"
import * as amdModule57 from "./models/vocabulary.js"
import * as amdModule58 from "./router.js"
import * as amdModule59 from "./sentry.js"
import * as amdModule60 from "./serializers/application.js"
import * as amdModule61 from "./serializers/authentication.js"
import * as amdModule62 from "./serializers/course.js"
import * as amdModule63 from "./serializers/curriculum-inventory-export.js"
import * as amdModule64 from "./serializers/curriculum-inventory-report.js"
import * as amdModule65 from "./serializers/curriculum-inventory-sequence-block.js"
import * as amdModule66 from "./serializers/learning-material.js"
import * as amdModule67 from "./serializers/offering.js"
import * as amdModule68 from "./serializers/report.js"
import * as amdModule69 from "./serializers/school-config.js"
import * as amdModule70 from "./serializers/session.js"
import * as amdModule71 from "./serializers/user-session-material-status.js"
import * as amdModule72 from "./services/api-version.js"
import * as amdModule73 from "./services/calendar-event-tooltip.js"
import * as amdModule74 from "./services/current-user.js"
import * as amdModule75 from "./services/data-loader.js"
import * as amdModule76 from "./services/fetch.js"
import * as amdModule77 from "./services/flash-messages.js"
import * as amdModule78 from "./services/graphql.js"
import * as amdModule79 from "./services/ilios-config.js"
import * as amdModule80 from "./services/loading-opacity-tracker.js"
import * as amdModule81 from "./services/local-storage.js"
import * as amdModule82 from "./services/locale-days.js"
import * as amdModule83 from "./services/new-version.js"
import * as amdModule84 from "./services/page-title.js"
import * as amdModule85 from "./services/permission-checker.js"
import * as amdModule86 from "./services/permission-matrix.js"
import * as amdModule87 from "./services/preferences.js"
import * as amdModule88 from "./services/preserve-scroll.js"
import * as amdModule89 from "./services/reporting.js"
import * as amdModule90 from "./services/school-config.js"
import * as amdModule91 from "./services/school-events.js"
import * as amdModule92 from "./services/search.js"
import * as amdModule93 from "./services/server-variables.js"
import * as amdModule94 from "./services/session.js"
import * as amdModule95 from "./services/store.js"
import * as amdModule96 from "./services/timezone.js"
import * as amdModule97 from "./services/user-events.js"
import * as amdModule98 from "./session-stores/application.js"
import * as amdModule99 from "./transforms/boolean.js"
import * as amdModule100 from "./transforms/date.js"
import * as amdModule101 from "./transforms/number.js"
import * as amdModule102 from "./transforms/string.js"
import * as amdModule103 from "./utils/array-helpers.js"
import * as amdModule104 from "./utils/as-array.js"
import * as amdModule105 from "./utils/clone-learner-group.js"
import * as amdModule106 from "./utils/color-change.js"
import * as amdModule107 from "./utils/count-digits.js"
import * as amdModule108 from "./utils/create-download-file.js"
import * as amdModule109 from "./utils/create-typed-learning-material-proxy.js"
import * as amdModule110 from "./utils/current-academic-year.js"
import * as amdModule111 from "./utils/escape-reg-exp.js"
import * as amdModule112 from "./utils/get-user-name-for-graph-user.js"
import * as amdModule113 from "./utils/html-server-variables.js"
import * as amdModule114 from "./utils/is-equal.js"
import * as amdModule115 from "./utils/is-object.js"
import * as amdModule116 from "./utils/is-promise.js"
import * as amdModule117 from "./utils/json-api-utc-date.js"
import * as amdModule118 from "./utils/jwt-utils.js"
import * as amdModule119 from "./utils/launch-worker.js"
import * as amdModule120 from "./utils/load-quill-editor.js"
import * as amdModule121 from "./utils/offering-date-block.js"
import * as amdModule122 from "./utils/pcrs-uri-to-number.js"
import * as amdModule123 from "./utils/preload-course.js"
import * as amdModule124 from "./utils/query-utils.js"
import * as amdModule125 from "./utils/random-string.js"
import * as amdModule126 from "./utils/readable-file-size.js"
import * as amdModule127 from "./utils/scroll-into-view.js"
import * as amdModule128 from "./utils/setup-fontawesome.js"
import * as amdModule129 from "./utils/sort-cohorts.js"
import * as amdModule130 from "./utils/sortable-by-position.js"
import * as amdModule131 from "./initializers/resize-observer-polyfill.js"
import * as amdModule132 from "./services/resize-observer.js"
import * as amdModule133 from "./initializers/viewport-config.js"
import * as amdModule134 from "./services/in-viewport.js"
import * as amdModule135 from "./services/-ensure-registered.js"
import * as amdModule136 from "./initializers/ember-simple-auth.js"
import * as amdModule137 from "./services/cookies.js"
import * as amdModule138 from "./services/keyboard.js"
import * as amdModule139 from "./services/intl.js"
import * as amdModule140 from "./services/file-queue.js"
import * as amdModule141 from "./templates/admin-dashboard.gjs"
import * as amdModule142 from "./controllers/admin-dashboard.js"
import * as amdModule143 from "./routes/admin-dashboard.js"
import * as amdModule144 from "./templates/application.gjs"
import * as amdModule145 from "./controllers/application.js"
import * as amdModule146 from "./routes/application.js"
import * as amdModule147 from "./templates/assign-students.gjs"
import * as amdModule148 from "./controllers/assign-students.js"
import * as amdModule149 from "./routes/assign-students.js"
import * as amdModule150 from "./templates/course-materials.gjs"
import * as amdModule151 from "./controllers/course-materials.js"
import * as amdModule152 from "./routes/course-materials.js"
import * as amdModule153 from "./templates/course-visualize-instructors.gjs"
import * as amdModule154 from "./controllers/course-visualize-instructors.js"
import * as amdModule155 from "./routes/course-visualize-instructors.js"
import * as amdModule156 from "./templates/course.gjs"
import * as amdModule157 from "./controllers/course.js"
import * as amdModule158 from "./routes/course.js"
import * as amdModule159 from "./templates/course/index.gjs"
import * as amdModule160 from "./controllers/course/index.js"
import * as amdModule161 from "./routes/course/index.js"
import * as amdModule162 from "./templates/course/publishall.gjs"
import * as amdModule163 from "./controllers/course/publishall.js"
import * as amdModule164 from "./routes/course/publishall.js"
import * as amdModule165 from "./templates/course/rollover.gjs"
import * as amdModule166 from "./controllers/course/rollover.js"
import * as amdModule167 from "./routes/course/rollover.js"
import * as amdModule168 from "./templates/course/publication-check.gjs"
import * as amdModule169 from "./routes/course/publication-check.js"
import * as amdModule170 from "./templates/courses.gjs"
import * as amdModule171 from "./controllers/courses.js"
import * as amdModule172 from "./routes/courses.js"
import * as amdModule173 from "./templates/dashboard.gjs"
import * as amdModule174 from "./routes/dashboard.js"
import * as amdModule175 from "./templates/dashboard/calendar.gjs"
import * as amdModule176 from "./controllers/dashboard/calendar.js"
import * as amdModule177 from "./routes/dashboard/calendar.js"
import * as amdModule178 from "./templates/dashboard/materials.gjs"
import * as amdModule179 from "./controllers/dashboard/materials.js"
import * as amdModule180 from "./routes/dashboard/materials.js"
import * as amdModule181 from "./routes/dashboard/activities.js"
import * as amdModule182 from "./routes/dashboard/index.js"
import * as amdModule183 from "./templates/dashboard/week.gjs"
import * as amdModule184 from "./routes/dashboard/week.js"
import * as amdModule185 from "./templates/error.gjs"
import * as amdModule186 from "./controllers/error.js"
import * as amdModule187 from "./templates/events.gjs"
import * as amdModule188 from "./controllers/events.js"
import * as amdModule189 from "./routes/events.js"
import * as amdModule190 from "./templates/instructor-group.gjs"
import * as amdModule191 from "./controllers/instructor-group.js"
import * as amdModule192 from "./routes/instructor-group.js"
import * as amdModule193 from "./templates/instructor-groups.gjs"
import * as amdModule194 from "./controllers/instructor-groups.js"
import * as amdModule195 from "./routes/instructor-groups.js"
import * as amdModule196 from "./templates/learner-group.gjs"
import * as amdModule197 from "./controllers/learner-group.js"
import * as amdModule198 from "./routes/learner-group.js"
import * as amdModule199 from "./templates/learner-groups.gjs"
import * as amdModule200 from "./controllers/learner-groups.js"
import * as amdModule201 from "./routes/learner-groups.js"
import * as amdModule202 from "./templates/myprofile.gjs"
import * as amdModule203 from "./controllers/myprofile.js"
import * as amdModule204 from "./routes/myprofile.js"
import * as amdModule205 from "./templates/pending-user-updates.gjs"
import * as amdModule206 from "./controllers/pending-user-updates.js"
import * as amdModule207 from "./routes/pending-user-updates.js"
import * as amdModule208 from "./templates/print-course.gjs"
import * as amdModule209 from "./controllers/print-course.js"
import * as amdModule210 from "./routes/print-course.js"
import * as amdModule211 from "./templates/program-year.gjs"
import * as amdModule212 from "./controllers/program-year.js"
import * as amdModule213 from "./routes/program-year.js"
import * as amdModule214 from "./templates/program.gjs"
import * as amdModule215 from "./controllers/program.js"
import * as amdModule216 from "./routes/program.js"
import * as amdModule217 from "./templates/program/index.gjs"
import * as amdModule218 from "./routes/program/index.js"
import * as amdModule219 from "./templates/programs.gjs"
import * as amdModule220 from "./controllers/programs.js"
import * as amdModule221 from "./routes/programs.js"
import * as amdModule222 from "./templates/reports.gjs"
import * as amdModule223 from "./routes/reports.js"
import * as amdModule224 from "./templates/reports/curriculum.gjs"
import * as amdModule225 from "./controllers/reports/curriculum.js"
import * as amdModule226 from "./routes/reports/curriculum.js"
import * as amdModule227 from "./templates/reports/subject.gjs"
import * as amdModule228 from "./controllers/reports/subject.js"
import * as amdModule229 from "./routes/reports/subject.js"
import * as amdModule230 from "./templates/reports/subjects.gjs"
import * as amdModule231 from "./controllers/reports/subjects.js"
import * as amdModule232 from "./routes/reports/subjects.js"
import * as amdModule233 from "./routes/reports/index.js"
import * as amdModule234 from "./templates/reports/curriculum-loading.gjs"
import * as amdModule235 from "./templates/school.gjs"
import * as amdModule236 from "./controllers/school.js"
import * as amdModule237 from "./routes/school.js"
import * as amdModule238 from "./templates/search.gjs"
import * as amdModule239 from "./controllers/search.js"
import * as amdModule240 from "./routes/search.js"
import * as amdModule241 from "./templates/session.gjs"
import * as amdModule242 from "./routes/session.js"
import * as amdModule243 from "./templates/session/copy.gjs"
import * as amdModule244 from "./controllers/session/copy.js"
import * as amdModule245 from "./routes/session/copy.js"
import * as amdModule246 from "./templates/session/index.gjs"
import * as amdModule247 from "./controllers/session/index.js"
import * as amdModule248 from "./routes/session/index.js"
import * as amdModule249 from "./templates/session/publication-check.gjs"
import * as amdModule250 from "./routes/session/publication-check.js"
import * as amdModule251 from "./templates/user.gjs"
import * as amdModule252 from "./controllers/user.js"
import * as amdModule253 from "./routes/user.js"
import * as amdModule254 from "./templates/users.gjs"
import * as amdModule255 from "./controllers/users.js"
import * as amdModule256 from "./routes/users.js"
import * as amdModule257 from "./templates/weeklyevents.gjs"
import * as amdModule258 from "./controllers/weeklyevents.js"
import * as amdModule259 from "./routes/weeklyevents.js"
import * as amdModule260 from "./templates/course-loading.gjs"
import * as amdModule261 from "./routes/course-loading.js"
import * as amdModule262 from "./templates/course-visualizations.gjs"
import * as amdModule263 from "./routes/course-visualizations.js"
import * as amdModule264 from "./templates/course-visualize-instructor.gjs"
import * as amdModule265 from "./routes/course-visualize-instructor.js"
import * as amdModule266 from "./templates/course-visualize-objectives.gjs"
import * as amdModule267 from "./routes/course-visualize-objectives.js"
import * as amdModule268 from "./templates/course-visualize-session-type.gjs"
import * as amdModule269 from "./routes/course-visualize-session-type.js"
import * as amdModule270 from "./templates/course-visualize-session-types.gjs"
import * as amdModule271 from "./routes/course-visualize-session-types.js"
import * as amdModule272 from "./templates/course-visualize-term.gjs"
import * as amdModule273 from "./routes/course-visualize-term.js"
import * as amdModule274 from "./templates/course-visualize-vocabularies.gjs"
import * as amdModule275 from "./routes/course-visualize-vocabularies.js"
import * as amdModule276 from "./templates/course-visualize-vocabulary.gjs"
import * as amdModule277 from "./routes/course-visualize-vocabulary.js"
import * as amdModule278 from "./templates/event-not-found.gjs"
import * as amdModule279 from "./routes/event-not-found.js"
import * as amdModule280 from "./routes/index.js"
import * as amdModule281 from "./templates/login.gjs"
import * as amdModule282 from "./routes/login.js"
import * as amdModule283 from "./templates/logout.gjs"
import * as amdModule284 from "./routes/logout.js"
import * as amdModule285 from "./routes/lti-login.js"
import * as amdModule286 from "./templates/program-year-visualize-objectives.gjs"
import * as amdModule287 from "./routes/program-year-visualize-objectives.js"
import * as amdModule288 from "./templates/schools.gjs"
import * as amdModule289 from "./routes/schools.js"
import * as amdModule290 from "./templates/session-type-visualize-vocabularies.gjs"
import * as amdModule291 from "./routes/session-type-visualize-vocabularies.js"
import * as amdModule292 from "./templates/session-type-visualize-vocabulary.gjs"
import * as amdModule293 from "./routes/session-type-visualize-vocabulary.js"
import * as amdModule294 from "./templates/courses-loading.gjs"
import * as amdModule295 from "./templates/dashboard-loading.gjs"
import * as amdModule296 from "./templates/four-oh-four.gjs"

let exportFastbootModules = {};





export default Object.assign(
  {},
defineModule0,
  {
"frontend/adapters/application": amdModule0,
"frontend/adapters/school": amdModule1,
"frontend/authenticators/ilios-jwt": amdModule2,
"frontend/classes/event": amdModule3,
"frontend/classes/events-base": amdModule4,
"frontend/classes/yup-validations": amdModule5,
"frontend/config/environment": amdModule6,
"frontend/deprecation-workflow": amdModule7,
"frontend/inflector": amdModule8,
"frontend/instance-initializers/sentry-performance": amdModule9,
"frontend/models/aamc-method": amdModule10,
"frontend/models/aamc-pcrs": amdModule11,
"frontend/models/aamc-resource-type": amdModule12,
"frontend/models/academic-year": amdModule13,
"frontend/models/assessment-option": amdModule14,
"frontend/models/authentication": amdModule15,
"frontend/models/cohort": amdModule16,
"frontend/models/competency": amdModule17,
"frontend/models/course-clerkship-type": amdModule18,
"frontend/models/course-learning-material": amdModule19,
"frontend/models/course-objective": amdModule20,
"frontend/models/course": amdModule21,
"frontend/models/curriculum-inventory-academic-level": amdModule22,
"frontend/models/curriculum-inventory-export": amdModule23,
"frontend/models/curriculum-inventory-institution": amdModule24,
"frontend/models/curriculum-inventory-report": amdModule25,
"frontend/models/curriculum-inventory-sequence-block": amdModule26,
"frontend/models/curriculum-inventory-sequence": amdModule27,
"frontend/models/ilm-session": amdModule28,
"frontend/models/ingestion-exception": amdModule29,
"frontend/models/instructor-group": amdModule30,
"frontend/models/learner-group": amdModule31,
"frontend/models/learning-material-status": amdModule32,
"frontend/models/learning-material-user-role": amdModule33,
"frontend/models/learning-material": amdModule34,
"frontend/models/mesh-concept": amdModule35,
"frontend/models/mesh-descriptor": amdModule36,
"frontend/models/mesh-previous-indexing": amdModule37,
"frontend/models/mesh-qualifier": amdModule38,
"frontend/models/mesh-term": amdModule39,
"frontend/models/mesh-tree": amdModule40,
"frontend/models/offering": amdModule41,
"frontend/models/pending-user-update": amdModule42,
"frontend/models/program-year-objective": amdModule43,
"frontend/models/program-year": amdModule44,
"frontend/models/program": amdModule45,
"frontend/models/report": amdModule46,
"frontend/models/school-config": amdModule47,
"frontend/models/school": amdModule48,
"frontend/models/session-learning-material": amdModule49,
"frontend/models/session-objective": amdModule50,
"frontend/models/session-type": amdModule51,
"frontend/models/session": amdModule52,
"frontend/models/term": amdModule53,
"frontend/models/user-role": amdModule54,
"frontend/models/user-session-material-status": amdModule55,
"frontend/models/user": amdModule56,
"frontend/models/vocabulary": amdModule57,
"frontend/router": amdModule58,
"frontend/sentry": amdModule59,
"frontend/serializers/application": amdModule60,
"frontend/serializers/authentication": amdModule61,
"frontend/serializers/course": amdModule62,
"frontend/serializers/curriculum-inventory-export": amdModule63,
"frontend/serializers/curriculum-inventory-report": amdModule64,
"frontend/serializers/curriculum-inventory-sequence-block": amdModule65,
"frontend/serializers/learning-material": amdModule66,
"frontend/serializers/offering": amdModule67,
"frontend/serializers/report": amdModule68,
"frontend/serializers/school-config": amdModule69,
"frontend/serializers/session": amdModule70,
"frontend/serializers/user-session-material-status": amdModule71,
"frontend/services/api-version": amdModule72,
"frontend/services/calendar-event-tooltip": amdModule73,
"frontend/services/current-user": amdModule74,
"frontend/services/data-loader": amdModule75,
"frontend/services/fetch": amdModule76,
"frontend/services/flash-messages": amdModule77,
"frontend/services/graphql": amdModule78,
"frontend/services/ilios-config": amdModule79,
"frontend/services/loading-opacity-tracker": amdModule80,
"frontend/services/local-storage": amdModule81,
"frontend/services/locale-days": amdModule82,
"frontend/services/new-version": amdModule83,
"frontend/services/page-title": amdModule84,
"frontend/services/permission-checker": amdModule85,
"frontend/services/permission-matrix": amdModule86,
"frontend/services/preferences": amdModule87,
"frontend/services/preserve-scroll": amdModule88,
"frontend/services/reporting": amdModule89,
"frontend/services/school-config": amdModule90,
"frontend/services/school-events": amdModule91,
"frontend/services/search": amdModule92,
"frontend/services/server-variables": amdModule93,
"frontend/services/session": amdModule94,
"frontend/services/store": amdModule95,
"frontend/services/timezone": amdModule96,
"frontend/services/user-events": amdModule97,
"frontend/session-stores/application": amdModule98,
"frontend/transforms/boolean": amdModule99,
"frontend/transforms/date": amdModule100,
"frontend/transforms/number": amdModule101,
"frontend/transforms/string": amdModule102,
"frontend/utils/array-helpers": amdModule103,
"frontend/utils/as-array": amdModule104,
"frontend/utils/clone-learner-group": amdModule105,
"frontend/utils/color-change": amdModule106,
"frontend/utils/count-digits": amdModule107,
"frontend/utils/create-download-file": amdModule108,
"frontend/utils/create-typed-learning-material-proxy": amdModule109,
"frontend/utils/current-academic-year": amdModule110,
"frontend/utils/escape-reg-exp": amdModule111,
"frontend/utils/get-user-name-for-graph-user": amdModule112,
"frontend/utils/html-server-variables": amdModule113,
"frontend/utils/is-equal": amdModule114,
"frontend/utils/is-object": amdModule115,
"frontend/utils/is-promise": amdModule116,
"frontend/utils/json-api-utc-date": amdModule117,
"frontend/utils/jwt-utils": amdModule118,
"frontend/utils/launch-worker": amdModule119,
"frontend/utils/load-quill-editor": amdModule120,
"frontend/utils/offering-date-block": amdModule121,
"frontend/utils/pcrs-uri-to-number": amdModule122,
"frontend/utils/preload-course": amdModule123,
"frontend/utils/query-utils": amdModule124,
"frontend/utils/random-string": amdModule125,
"frontend/utils/readable-file-size": amdModule126,
"frontend/utils/scroll-into-view": amdModule127,
"frontend/utils/setup-fontawesome": amdModule128,
"frontend/utils/sort-cohorts": amdModule129,
"frontend/utils/sortable-by-position": amdModule130,
"frontend/initializers/resize-observer-polyfill": amdModule131,
"frontend/services/resize-observer": amdModule132,
"frontend/initializers/viewport-config": amdModule133,
"frontend/services/in-viewport": amdModule134,
"frontend/services/-ensure-registered": amdModule135,
"frontend/initializers/ember-simple-auth": amdModule136,
"frontend/services/cookies": amdModule137,
"frontend/services/keyboard": amdModule138,
"frontend/services/intl": amdModule139,
"frontend/services/file-queue": amdModule140,
"frontend/templates/admin-dashboard": amdModule141,
"frontend/controllers/admin-dashboard": amdModule142,
"frontend/routes/admin-dashboard": amdModule143,
"frontend/templates/application": amdModule144,
"frontend/controllers/application": amdModule145,
"frontend/routes/application": amdModule146,
"frontend/templates/assign-students": amdModule147,
"frontend/controllers/assign-students": amdModule148,
"frontend/routes/assign-students": amdModule149,
"frontend/templates/course-materials": amdModule150,
"frontend/controllers/course-materials": amdModule151,
"frontend/routes/course-materials": amdModule152,
"frontend/templates/course-visualize-instructors": amdModule153,
"frontend/controllers/course-visualize-instructors": amdModule154,
"frontend/routes/course-visualize-instructors": amdModule155,
"frontend/templates/course": amdModule156,
"frontend/controllers/course": amdModule157,
"frontend/routes/course": amdModule158,
"frontend/templates/course/index": amdModule159,
"frontend/controllers/course/index": amdModule160,
"frontend/routes/course/index": amdModule161,
"frontend/templates/course/publishall": amdModule162,
"frontend/controllers/course/publishall": amdModule163,
"frontend/routes/course/publishall": amdModule164,
"frontend/templates/course/rollover": amdModule165,
"frontend/controllers/course/rollover": amdModule166,
"frontend/routes/course/rollover": amdModule167,
"frontend/templates/course/publication-check": amdModule168,
"frontend/routes/course/publication-check": amdModule169,
"frontend/templates/courses": amdModule170,
"frontend/controllers/courses": amdModule171,
"frontend/routes/courses": amdModule172,
"frontend/templates/dashboard": amdModule173,
"frontend/routes/dashboard": amdModule174,
"frontend/templates/dashboard/calendar": amdModule175,
"frontend/controllers/dashboard/calendar": amdModule176,
"frontend/routes/dashboard/calendar": amdModule177,
"frontend/templates/dashboard/materials": amdModule178,
"frontend/controllers/dashboard/materials": amdModule179,
"frontend/routes/dashboard/materials": amdModule180,
"frontend/routes/dashboard/activities": amdModule181,
"frontend/routes/dashboard/index": amdModule182,
"frontend/templates/dashboard/week": amdModule183,
"frontend/routes/dashboard/week": amdModule184,
"frontend/templates/error": amdModule185,
"frontend/controllers/error": amdModule186,
"frontend/templates/events": amdModule187,
"frontend/controllers/events": amdModule188,
"frontend/routes/events": amdModule189,
"frontend/templates/instructor-group": amdModule190,
"frontend/controllers/instructor-group": amdModule191,
"frontend/routes/instructor-group": amdModule192,
"frontend/templates/instructor-groups": amdModule193,
"frontend/controllers/instructor-groups": amdModule194,
"frontend/routes/instructor-groups": amdModule195,
"frontend/templates/learner-group": amdModule196,
"frontend/controllers/learner-group": amdModule197,
"frontend/routes/learner-group": amdModule198,
"frontend/templates/learner-groups": amdModule199,
"frontend/controllers/learner-groups": amdModule200,
"frontend/routes/learner-groups": amdModule201,
"frontend/templates/myprofile": amdModule202,
"frontend/controllers/myprofile": amdModule203,
"frontend/routes/myprofile": amdModule204,
"frontend/templates/pending-user-updates": amdModule205,
"frontend/controllers/pending-user-updates": amdModule206,
"frontend/routes/pending-user-updates": amdModule207,
"frontend/templates/print-course": amdModule208,
"frontend/controllers/print-course": amdModule209,
"frontend/routes/print-course": amdModule210,
"frontend/templates/program-year": amdModule211,
"frontend/controllers/program-year": amdModule212,
"frontend/routes/program-year": amdModule213,
"frontend/templates/program": amdModule214,
"frontend/controllers/program": amdModule215,
"frontend/routes/program": amdModule216,
"frontend/templates/program/index": amdModule217,
"frontend/routes/program/index": amdModule218,
"frontend/templates/programs": amdModule219,
"frontend/controllers/programs": amdModule220,
"frontend/routes/programs": amdModule221,
"frontend/templates/reports": amdModule222,
"frontend/routes/reports": amdModule223,
"frontend/templates/reports/curriculum": amdModule224,
"frontend/controllers/reports/curriculum": amdModule225,
"frontend/routes/reports/curriculum": amdModule226,
"frontend/templates/reports/subject": amdModule227,
"frontend/controllers/reports/subject": amdModule228,
"frontend/routes/reports/subject": amdModule229,
"frontend/templates/reports/subjects": amdModule230,
"frontend/controllers/reports/subjects": amdModule231,
"frontend/routes/reports/subjects": amdModule232,
"frontend/routes/reports/index": amdModule233,
"frontend/templates/reports/curriculum-loading": amdModule234,
"frontend/templates/school": amdModule235,
"frontend/controllers/school": amdModule236,
"frontend/routes/school": amdModule237,
"frontend/templates/search": amdModule238,
"frontend/controllers/search": amdModule239,
"frontend/routes/search": amdModule240,
"frontend/templates/session": amdModule241,
"frontend/routes/session": amdModule242,
"frontend/templates/session/copy": amdModule243,
"frontend/controllers/session/copy": amdModule244,
"frontend/routes/session/copy": amdModule245,
"frontend/templates/session/index": amdModule246,
"frontend/controllers/session/index": amdModule247,
"frontend/routes/session/index": amdModule248,
"frontend/templates/session/publication-check": amdModule249,
"frontend/routes/session/publication-check": amdModule250,
"frontend/templates/user": amdModule251,
"frontend/controllers/user": amdModule252,
"frontend/routes/user": amdModule253,
"frontend/templates/users": amdModule254,
"frontend/controllers/users": amdModule255,
"frontend/routes/users": amdModule256,
"frontend/templates/weeklyevents": amdModule257,
"frontend/controllers/weeklyevents": amdModule258,
"frontend/routes/weeklyevents": amdModule259,
"frontend/templates/course-loading": amdModule260,
"frontend/routes/course-loading": amdModule261,
"frontend/templates/course-visualizations": amdModule262,
"frontend/routes/course-visualizations": amdModule263,
"frontend/templates/course-visualize-instructor": amdModule264,
"frontend/routes/course-visualize-instructor": amdModule265,
"frontend/templates/course-visualize-objectives": amdModule266,
"frontend/routes/course-visualize-objectives": amdModule267,
"frontend/templates/course-visualize-session-type": amdModule268,
"frontend/routes/course-visualize-session-type": amdModule269,
"frontend/templates/course-visualize-session-types": amdModule270,
"frontend/routes/course-visualize-session-types": amdModule271,
"frontend/templates/course-visualize-term": amdModule272,
"frontend/routes/course-visualize-term": amdModule273,
"frontend/templates/course-visualize-vocabularies": amdModule274,
"frontend/routes/course-visualize-vocabularies": amdModule275,
"frontend/templates/course-visualize-vocabulary": amdModule276,
"frontend/routes/course-visualize-vocabulary": amdModule277,
"frontend/templates/event-not-found": amdModule278,
"frontend/routes/event-not-found": amdModule279,
"frontend/routes/index": amdModule280,
"frontend/templates/login": amdModule281,
"frontend/routes/login": amdModule282,
"frontend/templates/logout": amdModule283,
"frontend/routes/logout": amdModule284,
"frontend/routes/lti-login": amdModule285,
"frontend/templates/program-year-visualize-objectives": amdModule286,
"frontend/routes/program-year-visualize-objectives": amdModule287,
"frontend/templates/schools": amdModule288,
"frontend/routes/schools": amdModule289,
"frontend/templates/session-type-visualize-vocabularies": amdModule290,
"frontend/routes/session-type-visualize-vocabularies": amdModule291,
"frontend/templates/session-type-visualize-vocabulary": amdModule292,
"frontend/routes/session-type-visualize-vocabulary": amdModule293,
"frontend/templates/courses-loading": amdModule294,
"frontend/templates/dashboard-loading": amdModule295,
"frontend/templates/four-oh-four": amdModule296,
  },
  exportFastbootModules
);
